import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';
import Products from './components/Products/Products';
import Sales from './components/Sales/Sales';
import Customers from './components/Customers/Customers';
import Purchases from './components/Purchases/Purchases';
import Suppliers from './components/Suppliers/Suppliers';
import Reports from './components/Reports/Reports';
import APIDocumentation from './components/APIDocumentation/APIDocumentation';
import Settings from './components/Settings/Settings';
import Sidebar from './components/Sidebar/Sidebar';
import Header from './components/Header/Header';
import AskAIAssistant from './pages/AskAIAssistant/AskAIAssistant';
import styles from './App.module.css';

const App: React.FC = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const handleLogin = () => {
        setIsAuthenticated(true);
    };

    const handleLogout = () => {
        setIsAuthenticated(false);
    };

    if (!isAuthenticated) {
        return <Login onLogin={handleLogin} />;
    }

    return (
        <Router>
            <div className={styles.app}>
                <Sidebar />
                <div className={styles.mainContent}>
                    <Header onLogout={handleLogout} />
                    <div className={styles.contentArea}>
                        <Routes>
                            <Route path="/" element={<Navigate to="/dashboard" replace />} />
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/products" element={<Products />} />
                            <Route path="/sales" element={<Sales />} />
                            <Route path="/customers" element={<Customers />} />
                            <Route path="/purchases" element={<Purchases />} />
                            <Route path="/suppliers" element={<Suppliers />} />
                            <Route path="/ask-ai-assistant" element={<AskAIAssistant />} />
                            <Route path="/reports" element={<Reports />} />
                            <Route path="/api-docs" element={<APIDocumentation />} />
                            <Route path="/settings" element={<Settings />} />
                        </Routes>
                    </div>
                </div>
            </div>
        </Router>
    );
};

export default App; 